import { EmptyStatePlaceholder, Link, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { getHealthcareNfzSettingsPath } from '~legacy.p1';
import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { nfzLoginTranslationKeys } from '../../translations';

export const NfzLoginPanelNoConfiguration = (): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const healthcareProviderType = useGetCurrentHealthcareProviderType();

   return (
      <EmptyStatePlaceholder
         testId={'noNfzConfiguration'}
         heading={nfzLoginTranslationKeys.noNfzConfigurationHeader}
         subheading={protectFeature(
            'updatingProviderData',
            nfzLoginTranslationKeys.noNfzConfigurationMessageForAdmin,
            nfzLoginTranslationKeys.noNfzConfigurationMessageForPersonnel
         )}
      >
         {protectFeature(
            'updatingProviderData',
            <Link
               testId={'goToNfzIntegrationConfiguration'}
               label={nfzLoginTranslationKeys.configureNfzIntegration}
               onClick={() => {
                  push(getHealthcareNfzSettingsPath(healthcareProviderType), {});
               }}
            />,
            null
         )}
      </EmptyStatePlaceholder>
   );
};
